import type { TranslationDict } from './ja'

export const it: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Come giocare',
  helpAria: 'Come giocare',
  settings: 'Impostazioni',
  settingsAria: 'Impostazioni',
  close: 'Chiudi',
  closeAria: 'Chiudi',
  player: 'Giocatore',
  highscore: 'Record',
  start: 'Inizia',
  staminaEmpty: 'Stamina insufficiente',
  ranking: 'Sfida Territorio',
  difficultyTitle: 'Scegli difficoltà',
  difficultyStart: 'Inizia con questa difficoltà',
  back: 'Indietro',
  today: 'Oggi',
  weekly: 'Questa settimana',
  alltime: 'Totale',
  loading: 'Caricamento...',
  noScores: 'Nessun risultato. Diventa il primo campione!',
  loadFailed: 'Caricamento fallito',
  you: 'Tu',
  youConstant: 'TU',
  language: 'Lingua',
  languageNote: 'Supporta 18 lingue incluso il giapponese.',
  bgm: 'BGM',
  se: 'Effetti sonori',
  soundEnableAria: 'Attiva audio',
  soundDisableAria: 'Disattiva audio',
  adWatch: 'Guarda annuncio fino alla fine',
  adCancel: 'Non ora',
  rankSuffix: 'º',
  earnedPoints: 'ha ottenuto {score} pt',
  helpGoalTitle: '🎯 Obiettivo',
  helpGoalText: 'Posiziona i pezzi sulla scacchiera 9x9 e amplia i tuoi territori collegati. Vince chi ottiene il punteggio più alto.',
  helpWinTitle: '🏆 Condizioni di vittoria',
  helpWinFive: 'Metti cinque pezzi in fila in verticale, orizzontale o diagonale per una vittoria istantanea.',
  helpWinScore: 'Se la scacchiera si riempie, vince chi ha il punteggio più alto. Non ci sono pareggi.',
  helpScoreTitle: '💯 Punteggio',
  helpLineBonus: 'Bonus linea: ottieni punti per linee da 3, 4 e 5 pezzi in fila.',
  helpClusterBonus: 'Bonus territorio: ottieni più punti man mano che i tuoi gruppi collegati crescono.',
  helpKomi: 'Komi: il secondo giocatore riceve un bonus del +10% sul punteggio.',
  helpControlsTitle: '🖱️ Controlli',
  helpControlsText: 'Durante il tuo turno, tocca una casella vuota per posizionare un pezzo.',
  helpTipsTitle: '💡 Suggerimenti',
  helpTipHell: 'Prova HELL quando vuoi la sfida più difficile.',
  helpTipCluster: 'Non cercare solo il cinque in fila. Anche i gruppi collegati più grandi aumentano il tuo punteggio.',
  resultWinFive: '🎉 Cinque in fila! Hai vinto!',
  resultWinScore: '🎉 Vittoria ai punti! Hai vinto!',
  resultLoseFive: '😿 La CPU ha fatto cinque in fila!',
  resultLoseScore: '😿 Sconfitta ai punti. Riprova!',
  resultDraw: '🤝 Pareggio',
  newHighscore: '🏆 Nuovo record!',
  scoreNone: 'Nessun punteggio',
  clusterBonus: 'Bonus territorio',
  retry: 'Gioca ancora',
  titleBack: 'Titolo',
  scoreHintPlaceStone: 'Posiziona una pietra',
  best: 'Migliore',
  clusterUnit: 'territorio',
  lineCount: '{len} in fila x{count}',
  turnCount: 'Mossa {count} · {difficulty}',
  boardPlayerPiece: 'Tuo pezzo',
  boardCpuPiece: 'Pezzo CPU',
  boardPlayerAlt: 'Tu',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'riga {row}, colonna {col}',
  boardPlaceable: 'posizionabile',
  boardEmpty: 'casella vuota',
  boardFlower: 'con fiore',
  firstPlayerAlt: 'Primo giocatore',
  playerFirst: 'Inizi tu!',
  playerSecond: 'Giochi per secondo (+{bonus}% komi)',
  cpuFirst: 'Inizia la CPU!',
  finalePlayerWin: 'Hai vinto!',
  finaleCpuWin: 'Vince la CPU!',
  finaleFive: 'Cinque in fila!',
  finaleTerritory: 'Sfida territori!',
  winnerAlt: 'Vincitore',
  loadingBoot: 'Avvio...',
  loadingConnect: 'Connessione...',
  loadingProfile: 'Caricamento profilo...',
  loadingAssets: 'Caricamento risorse...',
  loadingReady: 'Pronto',
  reauthRequiredTitle: 'Accesso richiesto',
  startupFailedTitle: 'Avvio fallito',
  reauthButton: 'Accedi di nuovo',
  reloadButton: 'Ricarica',
  lineReloginButton: 'Accesso LINE',
  reauthReason: 'Sessione scaduta. Accedi di nuovo.',
  errorReauth: 'Sessione scaduta. Accedi di nuovo.',
  errorForbidden: 'Non hai il permesso di usare questo gioco.',
  errorNotFound: 'Dati di gioco non trovati.',
  errorRateLimited: 'Rete occupata. Attendi e riprova.',
  errorServer: 'Impossibile connettersi al server. Attendi e ricarica.',
  errorCommunication: 'Errore di comunicazione. Ricarica.',
  errorNetwork: 'Impossibile connettersi alla rete. Controlla la connessione e ricarica.',
  errorStartup: 'Avvio fallito. Ricarica.',
  settingsTabGeneral: 'Impostazioni',
  settingsTabAccount: 'Account',
  settingsTabInfo: 'Info',
  account: 'Account',
  linked: 'Collegato',
  guest: 'Ospite',
  loggedInWith: 'Accesso effettuato con {provider}',
  loggedIn: 'Accesso effettuato',
  playingAsGuest: 'Stai giocando come ospite.',
  appleLoginBusy: 'Accesso con Apple...',
  appleLogin: 'Accedi con Apple',
  googleLoginBusy: 'Accesso con Google...',
  googleLogin: 'Accedi con Google',
  logoutBusy: 'Disconnessione...',
  logout: 'Esci',
  logoutSuccess: 'Disconnesso',
  logoutFailed: 'Disconnessione fallita',
  appInfo: 'Informazioni app',
  appName: 'Nome app',
  version: 'Versione',
  legalInfo: 'Informazioni legali',
  terms: 'Termini di utilizzo',
  privacy: 'Informativa sulla privacy',
  operator: 'Operatore',
  contact: 'Contatti',
  copyTap: 'Tocca per copiare',
  idCopied: 'ID copiato',
  copyFailed: 'Copia fallita',
  other: 'Altro',
  reportAd: 'Segnala annuncio inappropriato',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Modifica profilo',
  displayName: 'Nome visualizzato',
  displayNamePlaceholder: 'Inserisci un nome',
  chooseIcon: 'Scegli icona',
  iconLoadFailed: 'Caricamento icone fallito.',
  saveFailed: 'Salvataggio fallito. Riprova.',
  noIcons: 'Nessuna icona disponibile.',
  save: 'Salva',
  saving: 'Salvataggio...',
  staminaAria: 'Stamina {stamina} / {max}',
  nextRecovery: 'Prossimo recupero tra {time}',
  adPlaying: 'Riproduzione annuncio...',
  recoverFullAd: 'Guarda annuncio per recuperare tutta la stamina',
  dailyBonusAria: 'Guarda annuncio fino alla fine per +5 stamina',
  dailyBonusAd: 'Guarda annuncio per +5 stamina',
  legalLastUpdated: 'Ultimo aggiornamento: {date}',
  privacyTitle: 'Informativa sulla privacy',
  termsTitle: 'Termini di utilizzo',
  adPlayingAria: 'Annuncio in corso',
  adBadge: '▶ Annuncio',
  adRemaining: '{seconds}s rimanenti',
  adDevHint: 'Annuncio di prova. In produzione verrà mostrato un video AdMob.',
  adRewardRequirement: 'Guarda l’annuncio fino alla fine per ricevere questa ricompensa.',
  adRewardStaminaDetail: 'Ricompensa: stamina ripristinata al massimo',
  adRewardDailyBonusDetail: 'Ricompensa: +{amount} stamina come bonus giornaliero',
  adRewardIncompleteNote: 'Se chiudi prima della fine, non riceverai la ricompensa.',
  adSkipAria: 'Salta annuncio',
  adSkip: 'Salta ✕',
  adSkipAfter: 'Salta tra {seconds}s',
  offlineMessage: 'Impossibile connettersi al server. Alcune funzioni potrebbero non essere disponibili.',
  reconnecting: 'Riconnessione...',
  reconnect: 'Riconnetti',
  signInTitle: 'Accedi',
  signInBusy: 'Accesso...',
  signInCancelNote: 'Se annulli l’accesso, puoi continuare come ospite (alcune funzioni non disponibili).',
  processing: 'In corso...',
  recoverConfirmTitle: 'Conferma sovrascrittura dati',
  recoverConfirmMessage: 'Esistono già dati collegati a questo account. Continuando, i dati ospite su questo dispositivo verranno sostituiti. Vuoi continuare?',
  recoverConfirmContinue: 'Ripristina',
  recoverConfirmCancel: 'Annulla',
  unlinkConfirmTitle: 'Scollega account',
  unlinkConfirmMessage: 'Se scolleghi questo provider, il dispositivo tornerà al gioco come ospite. I dati Hub restano disponibili se accedi di nuovo con lo stesso provider su un altro dispositivo.',
  unlinkConfirmContinue: 'Scollega',
  unlinkConfirmCancel: 'Annulla',
  deleteConfirmTitle: 'Conferma eliminazione account',
  deleteConfirmMessage: 'L’eliminazione dell’account rimuoverà record, dati di accesso, account collegati e inviti.\nL’azione è irreversibile. Vuoi davvero eliminare l’account?',
  deleteConfirmContinue: 'Elimina account',
  deleteConfirmCancel: 'Annulla',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: '{seconds}s rimanenti',
  matchmakingTimeoutMessage: 'Nessun avversario trovato in tempo. Riprova.',
  difficultyEasyName: 'Facile',
  difficultyEasyDescription: 'L’avversario è un po’ distratto',
  difficultyNormalName: 'Normale',
  difficultyNormalDescription: 'L’avversario a volte commette errori',
  difficultyHardName: 'Difficile',
  difficultyHardDescription: 'L’avversario ha un’ottima visione di gioco',
  difficultyHellName: 'Estrema',
  difficultyHellDescription: 'L’avversario è forte e anticipa le mosse',
}
